export default class Utils{
  static getPlainPhoneNumberFromString(phoneNumber:string){
    // Null-safe: callers pass a cleared phone field (manual-card-dialog's
    // clearPhoneNumber sets this.phoneNumber = null, then immediately calls
    // updatePhoneNumber). Returning '+1' keeps every `.length === 12` validity
    // check falsy, so an empty field reads as invalid instead of crashing.
    // let ph = phoneNumber.replace(/[\s()-]/g, '');
    let ph = (phoneNumber || '').replace(/[\s()-]/g, '');
    return '+1' + ph.substring(0,10);
  }

  static getFormattedPhoneNumber(phoneNumber){
    // Null-safe for the same reason — several callers pass
    // bot_order.phone_number straight through, which is null on a new order.
    // return phoneNumber.replace(/^(\+1)(\d{0,3})(\d{0,3})(\d{0,4})/, '($2) $3-$4');
    return (phoneNumber || '').replace(/^(\+1)(\d{0,3})(\d{0,3})(\d{0,4})/, '($2) $3-$4');
  }

  static toISOLocal(d) {
    var z  = n =>  ('0' + n).slice(-2);
    var zz = n => ('00' + n).slice(-3);
    var off = d.getTimezoneOffset();
    var sign = off > 0? '-' : '+';
    off = Math.abs(off);
  
    return d.getFullYear() + '-'
           + z(d.getMonth()+1) + '-' +
           z(d.getDate()) + 'T' +
           z(d.getHours()) + ':'  + 
           z(d.getMinutes()) + ':' +
           z(d.getSeconds()) + '.' +
           zz(d.getMilliseconds()) +
           sign + z(off/60|0) + ':' + z(off%60); 
  }
}
